import { createIcon } from '@consta/icons/Icon'
import type { FC, SVGProps } from 'react'

const IconMultiplyM: FC<SVGProps<SVGSVGElement>> = props => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M2.25844 2.25844C1.91385 2.60302 1.91385 3.16169 2.25844 3.50627L6.75216 8L2.25844 12.4937C1.91386 12.8383 1.91386 13.397 2.25844 13.7416C2.60302 14.0861 3.16169 14.0861 3.50627 13.7416L8 9.24784L12.4937 13.7416C12.8383 14.0861 13.397 14.0861 13.7416 13.7416C14.0861 13.397 14.0861 12.8383 13.7416 12.4937L9.24784 8L13.7416 3.50627C14.0861 3.16169 14.0861 2.60302 13.7416 2.25844C13.397 1.91385 12.8383 1.91385 12.4937 2.25844L8 6.75217L3.50627 2.25844C3.16169 1.91385 2.60302 1.91385 2.25844 2.25844Z" />
  </svg>
)

export const IconMultiply = createIcon({
  name: 'IconMultiply',
  l: IconMultiplyM,
  m: IconMultiplyM,
  s: IconMultiplyM,
  xs: IconMultiplyM,
})
